const initialModalStore = {
  deleteModal: {
    isOpen: false, message: '', callback: () => {}, id: '', deleteRequest: () => {}, objectName: '',
  },
};

export default initialModalStore;
